import { IQuantity, Quantity } from "../../../common/models/quantity.model";

interface IActions {
  openPanelToAdd: () => void;
  openPanelToEdit: () => void;
  openPanelSMSHistory: () => void;  
  deleteDriver: () => void;
}

export const generateItems = (quantity: IQuantity, actions: IActions, t: any) => {
  switch (quantity) {
    case Quantity.NONE:
      return [
        {
          key: "add",
          text: t('drivers.commands.add'),
          iconProps: { iconName: "add" },
          name: "add",
          onClick: actions.openPanelToAdd,
        }
      ];
    case Quantity.ONE:
      return [
        {
          key: "add",
          text: t('drivers.commands.add'),
          iconProps: { iconName: "add" },
          name: "add",
          onClick: actions.openPanelToAdd,
        },
        {
          key: "edit",
          text: t('drivers.commands.edit'),
          iconProps: { iconName: "edit" },
          name: "edit",
          onClick: actions.openPanelToEdit,
        },
        {
          key: "delete",
          text: t('drivers.commands.delete'),
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.deleteDriver,
        },
        {
          key: "smsHistory",
          text: t('drivers.commands.smsHistory'),
          iconProps: { iconName: "message" },
          name: "smsHistory",
          onClick: actions.openPanelSMSHistory,
        },
      ];
    default:
      return [];
  }
};
